var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Loader } from "sb-resp-ui";
import "blocks/LeagueListPresenter/ui/LeagueListPresenter.less";
import * as CMP from "../components";
import { CouponButtonPosition } from "../../../Typings";
// external components
// import * as CMP from "../components";
/*
    Setup testing tools for MobX
    uncomment the <DevTools /> at the end of the LeagueListPresenter component
*/
// import DevTools from "mobx-react-devtools";
// import { setLogEnabled, setUpdatesEnabled, setGraphEnabled } from "mobx-react-devtools";
// if (process.env.NODE_ENV === "development") {
//     setLogEnabled(true);
//     setUpdatesEnabled(true);
//     setGraphEnabled(true);
// }
var LeagueListPresenter = /** @class */ (function (_super) {
    __extends(LeagueListPresenter, _super);
    function LeagueListPresenter(props) {
        var _this = _super.call(this, props) || this;
        // setup dictionary
        _this.dict = props.dict;
        _this.refEl = React.createRef();
        // setup data provider
        _this.state = {
            dataProvider: props.dataProvider
        };
        return _this;
    }
    LeagueListPresenter.prototype.renderLeagues = function (options) {
        return (React.createElement("div", { className: options.className, ref: this.refEl },
            this.renderHeader(options.sportId, options.headerPhrase),
            this.renderContent(options.view),
            this.renderCouponButton(options.sportId),
            this.renderShowAllBtn(options.hasTopLeaguesOnly)));
    };
    LeagueListPresenter.prototype.renderHeader = function (sportId, headerPhrase) {
        return (React.createElement(CMP.SportHeader, { label: this.dict[headerPhrase] }, this.state.dataProvider.options.cms.isCouponCreationEnabled &&
            this.state.dataProvider.selectedLeagues.length ?
            React.createElement(CMP.CreateCouponBtn, { sportId: sportId, onClick: this.state.dataProvider.openCouponTranspiler, label: this.dict.CreateCoupon, count: this.state.dataProvider.selectedLeagues.length, parentRef: this.refEl, cuponPosition: this.props.dataProvider.options.cms.couponButtonPosition, wrapEl: this.props.dataProvider.options.navHandler.centerPanelHolder.element, tabletTopOffSet: this.props.dataProvider.options.navHandler.topPanelsHolder.element.getBoundingClientRect().height, deviceType: this.props.dataProvider.deviceDetect }) : ""));
    };
    LeagueListPresenter.prototype.renderContent = function (view) {
        return (React.createElement("div", { className: "rj-league-list__content", "data-uat": "div-league-list-content" }, view));
    };
    LeagueListPresenter.prototype.renderCouponButton = function (sportId) {
        return (this.props.dataProvider.options.cms.couponButtonPosition === CouponButtonPosition.Static
            && this.state.dataProvider.showBottomButton &&
            React.createElement(CMP.CreateCouponBtn, { sportId: sportId, onClick: this.state.dataProvider.openCouponTranspiler, label: this.dict.CreateCoupon, count: this.state.dataProvider.selectedLeagues.length, parentRef: this.refEl, cuponPosition: this.props.dataProvider.options.cms.couponButtonPosition, wrapEl: this.props.dataProvider.options.navHandler.centerPanelHolder.element, tabletTopOffSet: this.props.dataProvider.options.navHandler.topPanelsHolder.element.getBoundingClientRect().height, deviceType: this.props.dataProvider.deviceDetect }));
    };
    LeagueListPresenter.prototype.renderShowAllBtn = function (hasTopLeagues) {
        return !hasTopLeagues && this.state.dataProvider.leagues.length > this.state.dataProvider.numberOfAllLeaguesShownByDefault &&
            React.createElement(CMP.ShowAllBtn, { onClick: this.state.dataProvider.showAllButtonHandler, expanded: this.state.dataProvider.showAllButton.expanded, label: this.state.dataProvider.showAllButton.label });
    };
    LeagueListPresenter.prototype.getRenderParams = function (className, sportId, headerPhrase, view, hasTopLeaguesOnly) {
        return {
            className: className,
            sportId: sportId,
            headerPhrase: headerPhrase,
            view: view,
            hasTopLeaguesOnly: hasTopLeaguesOnly
        };
    };
    LeagueListPresenter.prototype.getLeagueItem = function (league) {
        return React.createElement(CMP.LeagueItem, { key: league.isTopLeague ? "LeagueItem-" + league.id + "-TopLeague" : "LeagueItem-" + league.id, league: league, showCheckbox: this.state.dataProvider.options.cms.isCouponCreationEnabled, toggleSelectedLeague: this.state.dataProvider.toggleSelectedLeague.bind(this.state, league.id), openLeagueTranspiler: this.state.dataProvider.openLeagueTranspiler, tooltipMessage: this.dict.SelectedLeaguesLimitReached, showTooltip: this.state.dataProvider.selectedLeaguesLimitReached, selectedLeagueId: this.state.dataProvider.currentlySelectedLeague, dict: this.dict });
    };
    LeagueListPresenter.prototype.mapLeagues = function (array, views) {
        var _this = this;
        var topLeaguesCount = 1;
        var allLeaguesCount = 1;
        var numberOfAllLeaguesToRender = this.state.dataProvider.getNumberOfAllLeaguesToRender;
        array.forEach(function (league) {
            if (league.id) {
                var leagueItem = _this.getLeagueItem(league);
                if (league.isTopLeague && topLeaguesCount++ <= _this.state.dataProvider.numberOfTopLeaguesShown) {
                    views.topLeagues.push(leagueItem);
                }
                if (allLeaguesCount++ <= numberOfAllLeaguesToRender) {
                    views.allLeagues.push(leagueItem);
                }
            }
        });
    };
    LeagueListPresenter.prototype.renderView = function (view, topLeagues, allLeagues) {
        var isTopLeaguesOnly = this.state.dataProvider.leagues.every(function (league) { return league.isTopLeague === true; });
        return (isTopLeaguesOnly && view.topLeagues.length ?
            (React.createElement(React.Fragment, null, topLeagues)) :
            (this.state.dataProvider.options.cms.showTopLeaguesList && view.topLeagues.length ? (React.createElement(React.Fragment, null,
                React.createElement(React.Fragment, null, topLeagues),
                React.createElement(React.Fragment, null, allLeagues))) : allLeagues));
    };
    LeagueListPresenter.prototype.render = function () {
        /*
            How to use the dataProvider can be seen in an example here:
            https://confluence.sbtech.com/display/FR/React+LeagueListPresenter+Example
        */
        var view = {
            allLeagues: [],
            topLeagues: []
        };
        var sportId = this.state.dataProvider.sportId;
        this.mapLeagues(this.state.dataProvider.getLeaguesToProcess, view);
        var allLeaguesListClass = "rj-league-list";
        var leagueListClass = "rj-league-list__top-leagues";
        var topLeaguesParams = this.getRenderParams(leagueListClass, sportId, this.state.dataProvider.options.cms.topLeaguesPhrase, view.topLeagues, true);
        var allLeaguesParams = this.getRenderParams(allLeaguesListClass, sportId, this.state.dataProvider.options.cms.headerPhrase || this.state.dataProvider.options.cms.allLeaguesPhrase, view.allLeagues, false);
        var topLeagues = this.renderLeagues(topLeaguesParams);
        var allLeagues = this.renderLeagues(allLeaguesParams);
        return (this.state.dataProvider.isDataLoaded ?
            this.state.dataProvider.leagues.length > 0 && this.renderView(view, topLeagues, allLeagues) :
            React.createElement("div", { className: "rj-league-list", "data-uat": "div-league-list-loader" },
                React.createElement(Loader, null)));
    };
    LeagueListPresenter = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], LeagueListPresenter);
    return LeagueListPresenter;
}(React.Component));
export { LeagueListPresenter };
//# sourceMappingURL=LeagueListPresenter.js.map